/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_CategoryInputs */

const en_col_category = /** @type {(inputs: Col_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Col_CategoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const col_category = /** @type {((inputs?: Col_CategoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_CategoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_col_category(inputs)
});